import React from 'react';
import ReactDOM from 'react-dom';
import './themes/import.scss';
// import 'bootstrap/dist/css/bootstrap.min.css'; // [PCT] coloquei dentro index.scss
import App from './App';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import { Store } from './store';
import { startVersionMonitor, STARTUP_VERSION_CHECK_TIMEOUT_MS } from './services/versionMonitor';
import { logAppVersion } from './services/logAppVersion';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

(async () => {
    const versionMonitor = startVersionMonitor({ initialCheck: false });
    let startupTimeout;
    const shouldReload = await Promise.race([
        versionMonitor.checkOnStartup(),
        new Promise((resolve) => {
            startupTimeout = window.setTimeout(() => {
                versionMonitor.cancelStartupCheck();
                resolve(false);
            }, STARTUP_VERSION_CHECK_TIMEOUT_MS);
        }),
    ]);
    window.clearTimeout(startupTimeout);
    if (shouldReload) return;

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: Infinity,
            },
        },
    });

    ReactDOM.render(
        <Provider store={Store}>
            <QueryClientProvider client={queryClient}>
                <App />
                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </Provider>,
        document.getElementById('root'),
    );

    logAppVersion();

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.register();
})();
